<template>
  <div>
    <!-- 分销商设置 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>分销商设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="contentBox">
      <div class="contentOne">
        <div>
          <div>基本信息</div>
          <el-divider></el-divider>
          <el-descriptions :column="1" direction="vertical">
            <el-descriptions-item label="简称">{{form.Name}}</el-descriptions-item>
            <el-descriptions-item label="全称">{{form.FullName}}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{form.LinkMan}}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{form.Phone}}</el-descriptions-item>
            <el-descriptions-item label="Email">{{form.E_Mail}}</el-descriptions-item>
            <el-descriptions-item label="分销商详细地址">{{form.Address}}</el-descriptions-item>
            <!-- <el-descriptions-item label="经纬度">
              <div>经度:121</div>
              <div>纬度:121</div>
            </el-descriptions-item> -->
          </el-descriptions>
        </div>
        
      </div>
      <div class="contentTwo">
        <div>基础设置</div>
        <el-divider></el-divider>
        <div class="TwoForm">
          <el-form v-model="form" :rules="rule">
            <el-form-item label="APPID:">
              <span class="xingA">*</span>
              <el-input v-model="form.UserCode" placeholder="APPID"></el-input>
            </el-form-item>
            <el-form-item label="softyktsecrect:">
              <el-input v-model="form.Diskey" :type='show?"text":"password"' placeholder="--" ></el-input>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button @click="changePass">{{ show?'隐藏':'查看' }}</el-button>
              <el-button @click="suijiDiskey">随机获取</el-button>
            </el-form-item>
            <el-form-item label="Token:">
              <el-input v-model="form.Token" placeholder="--" show-password></el-input>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button @click="suijiToekn">随机获取</el-button>
            </el-form-item>
            <el-form-item label="回调Url:"  prop="url">
              <el-input v-model="form.AgainUrl" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button  @click="itemYan">验证</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDistributorTwoInfo,
  setDistributorTwoApi
} from '@/request/index.js'
export default {
  data() {
    return {
      radio: "",
      form: {
        AgainUrl:''
      },
      rule:{
        url: [
          {type: 'url', message: `请输入正确的url`, trigger: 'change'}
        ]
      },
      show:false
    };
  },
  created(){
    this.getList()
  },
  methods:{
    changePass(){
      this.show = !this.show
    },
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      getDistributorTwoInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = res.data.result
        }
      })
    },
    // 基础设置保存
    preserve(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        first_quota:this.form.first_quota,
        end_quota:this.form.end_quota,
        limit:this.form.limit,
        sms:this.form.sms_flag
      }
      setDistributorQuotaRemind(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('保存成功')
          this.getList()
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    // 随机获取 验证
    suijiDiskey(){
     
      if(this.form.AgainUrl){
        const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
        if(reg.test(this.form.AgainUrl)){
        }else{
          this.$message.error('请输入合法url')
          return false
        }
      }
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      let num = ''
      for (let i = 0; i < 32; i++) {
         num += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.Diskey = num
      let data = {
        token:window.sessionStorage.getItem('Token'),
        Diskey:num,
        AgainUrl:this.form.AgainUrl,
        d_two_token:this.form.Token
      }
      setDistributorTwoApi(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('设置softyktsecrect成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    suijiToekn(){
      if(this.form.AgainUrl){
        const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
        if(reg.test(this.form.AgainUrl)){
        }else{
          this.$message.error('请输入合法url')
          return false
        }
      }else{
        this.$message.error('请输入url')
          return false
      }
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      let num = ''
      for (let i = 0; i < 32; i++) {
         num += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.d_two_token = num
      let data = {
        token:window.sessionStorage.getItem('Token'),
        Diskey:this.form.Diskey,
        AgainUrl:this.form.AgainUrl,
        d_two_token:num
      }
      setDistributorTwoApi(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('设置softyktsecrect成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    itemYan(){
      if(this.form.AgainUrl){
        const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
        if(reg.test(this.form.AgainUrl)){
        }else{
          this.$message.error('请输入合法url')
          return false
        }
      }else{
        this.$message.error('请输入url')
          return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        Diskey:this.form.Diskey,
        AgainUrl:this.form.AgainUrl,
        d_two_token:this.form.Token
      }
      setDistributorTwoApi(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('设置softyktsecrect成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.basicsForm {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .dw {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
    margin-left: 10px;
  }

  .itemOne {
    .el-input {
      width: 300px;
    }
  }
  .itemTwo {
    .el-input {
      width: 280px;
    }
  }
}
.contentBox {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .contentOne {
    min-width: 250px;
    width: 66.5%;
    height: 810px;
    // border: 1px solid pink;
    display: flex;
    flex-direction: column;
      background: #ffffff;
    justify-content: space-between;
    > div:nth-child(1) {
      width: 100%;
      height: 420px;
      padding: 20px;
      border-radius: 4px;
      box-sizing: border-box;
      > div:nth-child(1) {
        height: 40px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #000000;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      // height: 370px;
      margin: 20px 0;
      box-sizing: border-box;
      padding: 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px;
      /deep/.el-form-item {
        margin-bottom: 12px;
      }
      .itemBtn {
        display: flex;
        justify-content: center;
        margin-left: -100px;
        .el-button {
          width: 100px;
          border: none;
          background: #d9d9d9;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #ffffff;
        }
        .btnL {
          width: 100px;
          border: none;
          background: #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #ffffff;
          margin-left: 20px;
        }
      }
      > div:nth-child(1) {
        height: 40px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #000000;
      }
      > div:nth-child(3) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
        margin-bottom: 10px;
      }
    }
  }
  .contentTwo {
    min-width: 250px;
    width: 32.5%;
    height: 810px;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    > div:nth-child(1) {
      height: 40px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      color: #000000;
    }
    .TwoForm {
      /deep/.el-form-item__label {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
        position: relative;
      }
      .xingA {
        position: absolute;
        top: 0px;
        left: -5px;
        color: #e74c3c;
      }
      .itemBtn {
        display: flex;
        justify-content: flex-end;
        .el-button {
          width: 100px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #246deb;
        }
      }
    }
  }
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 10px 0;
}
// 描述列表
/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 0px;
}
/deep/.el-descriptions-item__label {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
/deep/.el-descriptions-item__content {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 13px;
}
/deep/ .el-descriptions__table tbody{
  margin-bottom: 1.3rem;
  display: block;
}
/deep/ .el-descriptions__table tbody tr:nth-child(2){
  margin-top: 0.3rem;
  display: block;
}
</style>